var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "loading" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xl-10 col mb-2" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col vertical-center mb-2" },
            [
              _c("b-skeleton", {
                staticClass: "mr-3",
                attrs: { type: "avatar", width: "2rem", height: "2rem" },
              }),
              _vm._v(" "),
              _c("b-skeleton", {
                staticClass: "mr-2",
                attrs: { width: "15%" },
              }),
              _vm._v(" "),
              _c("b-skeleton", {
                staticClass: "mr-2",
                attrs: { width: "4rem" },
              }),
              _vm._v(" "),
              _c("b-skeleton", { attrs: { width: "4rem" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-auto col-12 my-auto forward" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-row justify-content-end" },
              [
                _c("b-skeleton", {
                  staticClass: "mt-2 mr-2",
                  attrs: { width: "4rem" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-row justify-content-end" }, [
              _c(
                "div",
                {
                  staticClass:
                    "p-0 d-none d-lg-flex flex-row align-items-center",
                },
                [
                  _c("b-skeleton", {
                    staticClass: "mr-3",
                    attrs: { type: "avatar", width: "1rem", height: "1rem" },
                  }),
                  _vm._v(" "),
                  _c("b-skeleton", {
                    staticClass: "mr-2",
                    attrs: { width: "5rem", height: "2rem", type: "button" },
                  }),
                  _vm._v(" "),
                  _c("b-skeleton", {
                    staticClass: "mr-2",
                    attrs: { width: "5rem", height: "2rem", type: "button" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-lg-none d-flex" },
                [
                  _c("b-skeleton", {
                    attrs: { width: "1rem", height: "1.5rem" },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }